// Protection Rating Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Initialize protection rating functionality
  initProtectionRating();
  
  // Listen for language changes from the theme
  if (window.X && typeof window.X.on === 'function') {
    window.X.on('languageChanged', function() {
      // Wait a bit for the theme to fully update, then update displays
      setTimeout(function() {
        forceUpdateAllTemperatureDisplays();
      }, 100);
    });
  }
  
  // Also listen for any DOM changes that might indicate language switching
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        // Check if language selector visibility changed
        const target = mutation.target;
        if (target.classList.contains('language-selector') || target.hasAttribute('data-lang')) {
          setTimeout(forceUpdateAllTemperatureDisplays, 50);
        }
      }
    });
  });
  
  // Start observing
  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });
});

// Helper function to get current page language consistently
function getCurrentPageLanguage() {
  // Method 1: Check document lang attribute
  if (document.documentElement.lang === 'fr') {
    return 'fr';
  }
  // Method 2: Check URL path for /fr/
  else if (window.location.pathname.includes('/fr/')) {
    return 'fr';
  }
  // Default to English
  return 'en';
}

// Simplified language detection function for unit switching to avoid confusion
function getCurrentLanguageSimple() {
  // Method 1: Check if theme has language system (most reliable for real-time)
  if (window.X && window.X.language) {
    return window.X.language;
  }
  
  // Method 2: Check URL path
  if (window.location.pathname.includes('/fr/')) {
    return 'fr';
  }
  
  // Method 3: Check for visible language selectors (most reliable fallback)
  const languageSelectors = document.querySelectorAll('.language-selector');
  for (let selector of languageSelectors) {
    if (!selector.classList.contains('hide')) {
      const lang = selector.dataset.lang;
      if (lang) {
        return lang;
      }
    }
  }
  
  // Method 4: Check document lang attribute
  if (document.documentElement.lang === 'fr') {
    return 'fr';
  }
  
  // Default to English
  return 'en';
}

// Function to update all protection rating displays
function updateAllProtectionRatingDisplays() {
  const protectionRatings = document.querySelectorAll('.protection-rating');
  
  protectionRatings.forEach(function(rating) {
    const tempBox = rating.querySelector('.protection-rating__temp-box');
    const unitBtns = rating.querySelectorAll('.protection-rating__unit-btn');
    const tempCelsius = parseFloat(rating.dataset.tempRating);
    
    if (tempBox && !isNaN(tempCelsius)) {
      // Find which unit is currently active
      let currentUnit = 'c'; // default to Celsius
      for (let btn of unitBtns) {
        if (btn.classList.contains('protection-rating__unit-btn--active')) {
          currentUnit = btn.dataset.unit;
          break;
        }
      }
      
      // Update both temperature display and ranges
      updateTemperatureDisplay(tempBox, currentUnit, tempCelsius);
      updateTemperatureRanges(rating, currentUnit);
    }
  });
}

// Function to force update all temperature displays with current language
function forceUpdateAllTemperatureDisplays() {
  const protectionRatings = document.querySelectorAll('.protection-rating');
  
  protectionRatings.forEach(function(rating) {
    const tempBox = rating.querySelector('.protection-rating__temp-box');
    const unitBtns = rating.querySelectorAll('.protection-rating__unit-btn');
    const tempCelsius = parseFloat(rating.dataset.tempRating);
    
    if (tempBox && !isNaN(tempCelsius)) {
      // Find which unit is currently active
      let currentUnit = 'c'; // default to Celsius
      for (let btn of unitBtns) {
        if (btn.classList.contains('protection-rating__unit-btn--active')) {
          currentUnit = btn.dataset.unit;
          break;
        }
      }
      
      // Force update with current language
      updateTemperatureDisplay(tempBox, currentUnit, tempCelsius);
      updateTemperatureRanges(rating, currentUnit);
    }
  });
}

// Function to force refresh language and update specific protection rating
function forceRefreshLanguageAndUpdate(rating) {
  const tempBox = rating.querySelector('.protection-rating__temp-box');
  const unitBtns = rating.querySelectorAll('.protection-rating__unit-btn');
  const tempCelsius = parseFloat(rating.dataset.tempRating);
  
  if (tempBox && !isNaN(tempCelsius)) {
    // Find which unit is currently active
    let currentUnit = 'c'; // default to Celsius
    for (let btn of unitBtns) {
      if (btn.classList.contains('protection-rating__unit-btn--active')) {
        currentUnit = btn.dataset.unit;
        break;
      }
    }
    
    // Get the current page language using the helper function
    const currentLang = getCurrentPageLanguage();
    
    // Update displays
    updateTemperatureDisplay(tempBox, currentUnit, tempCelsius);
    updateTemperatureRanges(rating, currentUnit);
  }
}

function initProtectionRating() {
  const protectionRatings = document.querySelectorAll('.protection-rating');
  
  protectionRatings.forEach(function(rating) {
    const unitBtns = rating.querySelectorAll('.protection-rating__unit-btn');
    const tempBox = rating.querySelector('.protection-rating__temp-box');
    const indicator = rating.querySelector('.protection-rating__indicator');
    
    if (!unitBtns.length || !tempBox || !indicator) return;
    
    // Get initial temperature in Celsius from the data attribute
    const tempCelsius = parseFloat(rating.dataset.tempRating);
    
    // Store original values
    tempBox.dataset.tempCelsius = tempCelsius;
    tempBox.dataset.tempFahrenheit = Math.round((tempCelsius * 9/5) + 32);
    
    // Initialize the thermometer icon based on temperature
    updateThermometerIcon(rating, tempCelsius);
    
    // Initialize with Celsius display (as per the HTML default)
    updateTemperatureDisplay(tempBox, 'c', tempCelsius);
    
    // Add click event listeners to unit toggle buttons
    unitBtns.forEach(function(btn, btnIndex) {
      // Remove any existing handlers first
      btn.onclick = null;
      
      // Add new click handler
      btn.onclick = function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const unit = this.dataset.unit;
        
        // Remove active class from all buttons
        unitBtns.forEach(b => b.classList.remove('protection-rating__unit-btn--active'));
        
        // Add active class to clicked button
        this.classList.add('protection-rating__unit-btn--active');
        
        // Force refresh language and update displays
        forceRefreshLanguageAndUpdate(rating);
        
        // Add visual feedback
        this.style.transform = 'scale(0.95)';
        setTimeout(() => {
          this.style.transform = '';
        }, 150);
      };
    });
  });
}

function updateTemperatureDisplay(tempBox, unit, tempCelsius) {
  const tempFahrenheit = Math.round((tempCelsius * 9/5) + 32);
  
  // Get the current page language using the helper function
  const currentLang = getCurrentPageLanguage();
  const isFrench = currentLang === 'fr';
  
  if (unit === 'f') {
    if (isFrench) {
      tempBox.textContent = `Évaluation de température : ${tempFahrenheit}°F`;
    } else {
      tempBox.textContent = `Temperature Rating: ${tempFahrenheit}°F`;
    }
  } else {
    if (isFrench) {
      tempBox.textContent = `Évaluation de température : ${tempCelsius}°C`;
    } else {
      tempBox.textContent = `Temperature Rating: ${tempCelsius}°C`;
    }
  }
  
  // Update the indicator tooltip to show both units
  const indicator = tempBox.closest('.protection-rating').querySelector('.protection-rating__indicator');
  if (indicator) {
    indicator.title = `${tempCelsius}°C / ${tempFahrenheit}°F`;
    // Ensure the icon is still visible and correct
    const rating = tempBox.closest('.protection-rating');
    if (rating) {
      updateThermometerIcon(rating, tempCelsius);
    }
  }
  
  // Store the current unit for reference
  tempBox.dataset.currentUnit = unit;
}

function updateTemperatureRanges(rating, unit) {
  const categories = rating.querySelectorAll('.protection-rating__category-range');
  
  // Get the current page language using the helper function
  const currentLang = getCurrentPageLanguage();
  const isFrench = currentLang === 'fr';
  
  categories.forEach(function(category, index) {
    if (unit === 'f') {
      // Convert ranges to Fahrenheit
      switch(index) {
        case 0: // CHILLY: 10°C to 0°C
          if (isFrench) {
            category.textContent = '50°F à 32°F';
          } else {
            category.textContent = '50°F to 32°F';
          }
          break;
        case 1: // COLD: 0°C to -15°C
          if (isFrench) {
            category.textContent = '32°F à 5°F';
          } else {
            category.textContent = '32°F to 5°F';
          }
          break;
        case 2: // CRAZY COLD: -15°C to -25°C
          if (isFrench) {
            category.textContent = '5°F à -13°F';
          } else {
            category.textContent = '5°F to -13°F';
          }
          break;
        case 3: // CANADA COLD: -25°C to -45°C
          if (isFrench) {
            category.textContent = '-13°F à -49°F';
          } else {
            category.textContent = '-13°F to -49°F';
          }
          break;
      }
    } else {
      // Convert back to Celsius
      switch(index) {
        case 0: // CHILLY
          if (isFrench) {
            category.textContent = '10°C à 0°C';
          } else {
            category.textContent = '10°C to 0°C';
          }
          break;
        case 1: // COLD
          if (isFrench) {
            category.textContent = '0°C à -15°C';
          } else {
            category.textContent = '0°C to -15°C';
          }
          break;
        case 2: // CRAZY COLD
          if (isFrench) {
            category.textContent = '-15°C à -25°C';
          } else {
            category.textContent = '-15°C to -25°C';
          }
          break;
        case 3: // CANADA COLD
          if (isFrench) {
            category.textContent = '-25°C à -45°C';
          } else {
            category.textContent = '-25°C to -45°C';
          }
          break;
      }
    }
  });
}

// Function to update thermometer icon based on temperature
function updateThermometerIcon(rating, tempRating) {
  const indicator = rating.querySelector('.protection-rating__indicator');
  if (!indicator) return;
  
  // Clear existing content
  indicator.innerHTML = '';
  
  // Create and append the appropriate icon
  if (tempRating >= 0) {
    // Use cold thermometer icon for temperatures above 0°C
    indicator.innerHTML = `<svg height="24" viewBox="0 0 511.979 511.979" width="24" xmlns="http://www.w3.org/2000/svg"><g><path d="m315.492 61.06h75.774c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-75.774c-4.143 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z"/><path d="m315.492 95.689h37.888c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-37.888c-4.143 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z"/><path d="m391.267 115.689h-75.774c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h75.774c4.143 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z"/><path d="m315.492 165.317h37.888c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-37.888c-4.143 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z"/><path d="m391.267 184.803h-75.774c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h75.774c4.143 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z"/><path d="m315.492 234.432h37.888c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5h-37.888c-4.143 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5z"/><path d="m391.267 254.568h-75.774c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h75.774c4.143 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5z"/><path d="m353.38 289.197h-37.888c-4.143 0-7.5 3.358-7.5 7.5s3.357 7.5 7.5 7.5h37.888c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5z"/><path d="m277.475 315.247v-194.227c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v198.428c0 2.666 1.415 5.131 3.717 6.476 28.095 16.413 45.547 46.796 45.547 79.293 0 24.752-9.707 47.957-27.333 65.339-17.621 17.378-40.971 26.778-65.739 26.415-23.724-.33-46.158-9.786-63.17-26.626-17.014-16.841-26.694-39.176-27.257-62.891-.794-33.422 16.648-64.662 45.52-81.529 2.302-1.345 3.717-3.811 3.717-6.476v-261.949c0-23.435 19.064-42.5 42.499-42.5s42.5 19.065 42.5 42.5v28.686c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-28.686c0-31.706-25.794-57.5-57.5-57.5-31.705 0-57.5 25.794-57.5 57.5v257.746c-31.354 20.072-50.121 55.143-49.232 92.564.656 27.615 11.914 53.609 31.7 73.195 19.784 19.583 45.892 30.58 73.514 30.965.512.007 1.022.01 1.533.01 28.245 0 54.809-10.883 74.947-30.744 20.507-20.223 31.801-47.221 31.801-76.019-.001-36.353-18.768-70.43-49.264-89.97z"/><path d="m188.892 351.976c11.463-6.697 18.583-19.104 18.583-32.379v-24.369c0-4.142-3.357-7.5-7.5-7.5s-7.5 3.358-7.5 7.5v24.369c0 7.965-4.272 15.41-11.149 19.428-24.159 14.114-38.754 40.255-38.091 68.222.47 19.814 8.572 38.489 22.813 52.586s33.002 22.013 52.834 22.289c.342.004.682.006 1.022.006 20.36 0 39.492-7.827 53.969-22.103 14.745-14.542 22.865-33.953 22.865-54.659 0-27.187-14.604-52.607-38.113-66.342-6.878-4.018-11.15-11.462-11.15-19.427v-261.949c0-15.164-12.336-27.5-27.5-27.5-15.163 0-27.5 12.336-27.5 27.5v202.42c0 4.142 3.357 7.5 7.5 7.5s7.5-3.358 7.5-7.5v-117.379h25v176.907c0 13.276 7.121 25.683 18.584 32.379 18.924 11.055 30.68 31.513 30.68 53.39 0 16.66-6.534 32.278-18.398 43.979-11.842 11.679-27.521 18.018-44.257 17.778-15.926-.222-31.013-6.597-42.482-17.95s-17.993-26.368-18.37-42.282c-.536-22.511 11.213-43.553 30.66-54.914zm18.583-224.287v-70.041c0-6.893 5.607-12.5 12.5-12.5s12.5 5.607 12.5 12.5v70.041z"/></g></svg>`;
  } else {
    // Use warm thermometer icon for temperatures below 0°C
    indicator.innerHTML = `<svg height="24" viewBox="-55 0 512 512" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m394.222656 167.4375h-43.511718c-4.140626 0-7.5 3.359375-7.5 7.5s3.359374 7.5 7.5 7.5h43.511718c4.140625 0 7.5-3.359375 7.5-7.5s-3.359375-7.5-7.5-7.5zm0 0"/><path d="m350.710938 121.652344h19.753906c4.144531 0 7.5-3.359375 7.5-7.5 0-4.144532-3.355469-7.5-7.5-7.5h-19.753906c-4.140626 0-7.5 3.355468-7.5 7.5 0 4.140625 3.359374 7.5 7.5 7.5zm0 0"/><path d="m350.710938 60.863281h26.757812c4.140625 0 7.5-3.355469 7.5-7.5 0-4.140625-3.359375-7.5-7.5-7.5h-26.757812c-4.140626 0-7.5 3.359375-7.5 7.5 0 4.144531 3.359374 7.5 7.5 7.5zm0 0"/><path d="m377.46875 289.011719h-26.757812c-4.140626 0-7.5 3.355469-7.5 7.5 0 4.140625 3.359374 7.5 7.5 7.5h26.757812c4.140625 0 7.5-3.359375 7.5-7.5 0-4.144531-3.359375-7.5-7.5-7.5zm0 0"/><path d="m350.710938 243.222656h19.753906c4.144531 0 7.5-3.355468 7.5-7.5 0-4.140625-3.355469-7.5-7.5-7.5h-19.753906c-4.140626 0-7.5 3.359375-7.5 7.5 0 4.144532 3.359374 7.5 7.5 7.5zm0 0"/><path d="m127.109375 162.808594c12.40625 6.625 13.152344 8.125 16.453125 8.125 7.71875 0 10.378906-10.289063 3.671875-14.046875l-12.800781-7.164063 9.414062-3.855468c3.832032-1.570313 5.667969-5.953126 4.097656-9.785157-1.570312-3.832031-5.949218-5.664062-9.78125-4.097656l-20.449218 8.375-26.828125-15.023437 26.828125-15.023438c21.027344 8.414062 20.707031 8.9375 23.289062 8.9375 8.191406 0 10.425782-11.335938 2.84375-14.441406l-9.410156-3.855469 12.796875-7.167969c3.613281-2.019531 4.90625-6.59375 2.882813-10.207031-2.023438-3.613281-6.59375-4.902344-10.210938-2.878906l-12.796875 7.164062 1.632813-10.039062c.664062-4.085938-2.113282-7.941407-6.203126-8.605469-4.082031-.664062-7.941406 2.109375-8.605468 6.199219l-3.542969 21.808593-27.355469 15.316407v-31.351563l17.296875-13.746094c3.242188-2.578124 3.78125-7.292968 1.207031-10.539062-2.578124-3.242188-7.296874-3.78125-10.539062-1.203125l-7.964844 6.328125v-14.667969c0-4.140625-3.355468-7.5-7.5-7.5-4.140625 0-7.5 3.359375-7.5 7.5v14.667969l-7.960937-6.328125c-3.242188-2.578125-7.960938-2.039063-10.539063 1.207031-2.578125 3.242188-2.039062 7.957032 1.207032 10.535156l17.292968 13.75v31.347657l-27.351562-15.316407-3.546875-21.808593c-.664063-4.089844-4.515625-6.863281-8.605469-6.199219-4.085938.664062-6.863281 4.519531-6.199219 8.605469l1.632813 10.039062-12.800782-7.164062c-3.613281-2.023438-8.183593-.734375-10.207031 2.878906-2.023437 3.613281-.734375 8.1875 2.878907 10.207031l12.800781 7.167969-9.414063 3.855469c-3.832031 1.570312-5.664062 5.949218-4.097656 9.785156 1.574219 3.835938 5.957031 5.664062 9.785156 4.097656l20.445313-8.375 26.828125 15.023438-26.828125 15.019531-20.445313-8.375c-3.835937-1.566406-8.214844.265625-9.785156 4.101563-1.570312 3.832031.265625 8.210937 4.097656 9.78125l9.414063 3.855468-12.800781 7.167969c-6.707032 3.753906-4.042969 14.042969 3.671874 14.042969 3.300782 0 4.054688-1.503906 16.457032-8.125l-1.632813 10.042968c-.742187 4.5625 2.78125 8.703126 7.414063 8.703126 3.609375 0 6.792968-2.617188 7.390625-6.296876l3.546875-21.808593 27.351562-15.316407v31.347657l-17.292968 13.75c-3.246094 2.574219-3.785157 7.292969-1.207032 10.535156 2.578125 3.246094 7.296875 3.785156 10.539063 1.207031l7.960937-6.328125v14.667969c0 4.140625 3.359375 7.5 7.5 7.5 4.144532 0 7.5-3.359375 7.5-7.5v-14.667969c6.925782 5.015625 8.417969 7.957031 12.625 7.957031 7.070313-.003906 10.230469-8.957031 4.671875-13.371093l-17.296875-13.75v-31.347657l27.355469 15.316407 3.542969 21.808593c.597656 3.679688 3.78125 6.296876 7.394531 6.296876 4.640625 0 8.152344-4.152344 7.414063-8.703126zm0 0"/><path d="m318.148438 309.804688v-241.964844c0-37.40625-30.429688-67.839844-67.835938-67.839844s-67.839844 30.433594-67.839844 67.839844v241.964844c-28.023437 21.226562-44.636718 54.46875-44.636718 89.71875 0 62.019531 50.457031 112.476562 112.476562 112.476562s112.476562-50.457031 112.476562-112.476562c0-35.25-16.613281-68.492188-44.640624-89.71875zm-67.835938 187.195312c-53.75 0-97.476562-43.726562-97.476562-97.476562 0-31.6875 15.496093-61.511719 41.453124-79.773438 1.996094-1.40625 3.183594-3.695312 3.183594-6.136719v-245.773437c0-29.136719 23.703125-52.839844 52.839844-52.839844 29.132812 0 52.835938 23.703125 52.835938 52.839844v245.773437c0 2.441407 1.1875 4.730469 3.183593 6.136719 25.960938 18.265625 41.457031 48.085938 41.457031 79.773438 0 53.75-43.730468 97.476562-97.476562 97.476562zm0 0"/><path d="m283.140625 324.667969v-256.828125c0-18.105469-14.726563-32.832032-32.828125-32.832032s-32.832031 14.726563-32.832031 32.832032v23.222656c0 4.140625 3.359375 7.5 7.5 7.5 4.144531 0 7.5-3.359375 7.5-7.5v-23.222656c0-9.832032 8-17.832032 17.832031-17.832032s17.828125 8 17.828125 17.832032v222.253906h-35.660156v-168.960938c0-4.144531-3.355469-7.5-7.5-7.5-4.140625 0-7.5 3.355469-7.5 7.5v203.535157c-28.417969 12.808593-47.167969 41.484375-47.167969 72.949219 0 44.113281 35.886719 80 79.996094 80 44.113281 0 80-35.886719 80-80 .003906-31.464844-18.75-60.140626-47.167969-72.949219zm-32.828125 137.949219c-35.84375 0-65-29.15625-65-65 0-27 16.992188-51.476563 42.289062-60.898438 2.933594-1.09375 4.882813-3.898438 4.882813-7.027344v-24.597656h35.65625v24.597656c0 3.128906 1.949219 5.933594 4.882813 7.027344 25.296874 9.421875 42.289062 33.894531 42.289062 60.898438 0 35.84375-29.160156 65-65 65zm0 0"/></svg>`;
  }
}

// Temperature indicator positioning calculation
function updateTemperatureIndicator() {
  const protectionRatings = document.querySelectorAll('.protection-rating');
  
  protectionRatings.forEach(function(rating) {
    const indicator = rating.querySelector('.protection-rating__indicator');
    const rawTemp = rating.dataset.tempRating;
    let tempRating = parseFloat(rawTemp);
    
    // Handle negative temperatures more robustly
    if (rawTemp && rawTemp.startsWith('-') && isNaN(tempRating)) {
      const match = rawTemp.match(/-(\d+)/);
      if (match) {
        tempRating = -parseInt(match[1]);
      }
    }
    
    if (!indicator || isNaN(tempRating)) return;
    
    // Update the thermometer icon based on temperature
    updateThermometerIcon(rating, tempRating);
    
    // Calculate position to center the indicator within its temperature range column
    let position;
    
    if (tempRating >= 0 && tempRating <= 10) {
      // CHILLY range (0°C to 10°C) - center of 1st column (0% - 25%)
      position = 12.5;
    } else if (tempRating >= -15 && tempRating < 0) {
      // COLD range (-15°C to 0°C) - center of 2nd column (25% - 50%)
      position = 37.5;
    } else if (tempRating >= -25 && tempRating < -15) {
      // CRAZY COLD range (-25°C to -15°C) - center of 3rd column (50% - 75%)
      position = 62.5;
    } else if (tempRating >= -45 && tempRating < -25) {
      // CANADA COLD range (-45°C to -25°C) - center of 4th column (75% - 100%)
      position = 87.5;
    } else {
      // Outside ranges - default to middle
      position = 50;
    }
    
    // Apply position - center the indicator within its column
    const leftPosition = Math.max(0, Math.min(100, position));
    indicator.style.left = `${leftPosition}%`;
    indicator.style.transform = 'translateX(-50%)';
    
    // Add a small tooltip showing the exact temperature and range
    indicator.title = `${tempRating}°C`;
  });
}

// Call position update when page loads
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(updateTemperatureIndicator, 100);
});

// Update on window resize for responsive behavior
window.addEventListener('resize', updateTemperatureIndicator);

// Also try to update after a bit more time to catch any late-rendering
setTimeout(function() {
  updateTemperatureIndicator();
}, 500);

// Global click handler to ensure toggle functionality works
document.addEventListener('click', function(e) {
  if (e.target.classList.contains('protection-rating__unit-btn')) {
    // Manually trigger the toggle functionality
    const rating = e.target.closest('.protection-rating');
    if (rating) {
      const tempBox = rating.querySelector('.protection-rating__temp-box');
      const unitBtns = rating.querySelectorAll('.protection-rating__unit-btn');
      const tempCelsius = parseFloat(rating.dataset.tempRating);
      
      if (tempBox && !isNaN(tempCelsius)) {
        const unit = e.target.dataset.unit;
        
        // Remove active class from all buttons
        unitBtns.forEach(b => b.classList.remove('protection-rating__unit-btn--active'));
        
        // Add active class to clicked button
        e.target.classList.add('protection-rating__unit-btn--active');
        
        // Force refresh language and update displays
        forceRefreshLanguageAndUpdate(rating);
      }
    }
  }
});

// Product Features Tab Translation Support
function updateProductFeaturesTranslations() {
  const productFeatures = document.querySelectorAll('.product-feature__icon [data-i18n]');
  
  productFeatures.forEach(function(element) {
    const i18nData = element.getAttribute('data-i18n');
    if (i18nData) {
      // Parse the translation data and apply current language
      const translations = i18nData.split('||');
      
      // Get the current page language using the helper function
      const currentLang = getCurrentPageLanguage();
      
      if (currentLang === 'fr' && translations.length > 1) {
        element.textContent = translations[1]; // French text
      } else {
        element.textContent = translations[0]; // English text (default)
      }
    }
  });
}

// Listen for language changes to update product features
if (window.X && typeof window.X.on === 'function') {
  window.X.on('languageChanged', function() {
    setTimeout(function() {
      updateProductFeaturesTranslations();
    }, 100);
  });
}

